export default __webpack_public_path__ + "static/media/it_0.6712d858.mp3";